
/* styles */
require("!!vue-style-loader!css-loader!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-5561e39a!postcss-loader!sass-loader!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./CaseStudyVideo.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./CaseStudyVideo.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-5561e39a!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./CaseStudyVideo.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/shared-components/CaseStudy/CaseStudyVideo.vue
// module id = 70
// module chunks = 0